import migration150 from './1.5/1.5.0';
import migration160 from './1.6/1.6.0';

// The persist version is the highest key here (see store/index.ts),
// so adding a migration with a higher key bumps it.
export const migrations = {
  150: migration150,
  160: migration160,
};
